// Central SEO metadata config — sourced from the "Need Changes - Meta Data" spreadsheet.
// Each entry maps an exact pathname to its approved title + description.
// Used by <SeoApplier /> to inject <title>, <meta description>, canonical,
// og:title, og:description, twitter:title, twitter:description.
// Pages with their own dynamic SEO (e.g. /Latest_update/:id) are NOT listed
// here and continue to manage their own meta tags.

export const SITE_URL = "https://vidya365.in";

export const SEO_META = {
  "/": {
    title: "Best SSC & Banking Coaching Delhi: Expert Prep at VIDYA365",
    description: "Ace SSC & Banking exams with VIDYA365 in Delhi. Expert coaching, mock tests & flexible online/offline classes for RBI Grade B & NABARD.",
  },
  "/exams": {
    title: "SSC, Banking, RBI & NABARD Exams: Syllabus, Eligibility & Prep Guide | VIDYA365",
    description: "Your comprehensive guide to SSC, Banking, RBI Grade B, NABARD & government exams. Get syllabus, eligibility, and expert preparation tips.",
  },
  "/exams/rbi-grade-b": {
    title: "RBI Grade B Exam 2026: Syllabus, Pattern, Eligibility & Prep Tips",
    description: "Master the RBI Grade B Exam 2026. Find complete details on syllabus, eligibility, exam pattern, and expert preparation strategies.",
  },
  "/exams/nabard-grade-a": {
    title: "NABARD Grade A Exam 2026: Syllabus, Eligibility & Exam Pattern Guide",
    description: "Get ready for NABARD Grade A Exam 2026. Comprehensive syllabus, eligibility criteria, and exam pattern details to boost your preparation.",
  },
  "/exams/ssc-cgl": {
    title: "SSC CGL 2026: Ultimate Syllabus, Pattern & Eligibility Guide",
    description: "Your complete guide to the SSC CGL 2026 exam. Master syllabus, eligibility, and develop a winning preparation strategy.",
  },
  "/exams/ssc-chsl": {
    title: "SSC CHSL 2026: Syllabus, Eligibility & Exam Pattern Details",
    description: "Comprehensive details for SSC CHSL 2026 exam: syllabus, eligibility, and exam pattern for your preparation.",
  },
  "/exams/ssc-mts": {
    title: "SSC MTS Exam 2026: Updated Syllabus & Eligibility Guide",
    description: "Ace the SSC MTS Exam 2026 with our updated syllabus and clear eligibility details. Your preparation starts here.",
  },
  "/exams/ssc-cpo": {
    title: "SSC CPO 2026: Syllabus & Eligibility for SI Exam",
    description: "Get all details for the SSC CPO 2026 SI Exam. Covers syllabus, eligibility, and exam pattern for effective preparation.",
  },
  "/exams/ssc-gd": {
    title: "SSC GD Constable 2026: Syllabus & Eligibility Guide",
    description: "Your go-to source for SSC GD Constable 2026 exam details: syllabus, eligibility criteria, and preparation insights.",
  },
  "/exams/ssc-steno": {
    title: "SSC Stenographer 2026: Syllabus, Eligibility & Skill Test Guide",
    description: "Master SSC Stenographer 2026 with our guide to syllabus, eligibility, and crucial skill test information.",
  },
  "/exams/sbi-po": {
    title: "SBI PO 2026 Exam: Syllabus, Eligibility & Preparation Guide",
    description: "Detailed preparation for SBI PO 2026 Exam. Access syllabus, eligibility, and effective exam pattern insights.",
  },
  "/exams/ibps-po": {
    title: "IBPS PO 2026 Exam: Syllabus & Eligibility Insights",
    description: "Get crucial IBPS PO 2026 exam details: syllabus, eligibility criteria, and preparation tips to succeed.",
  },
  "/exams/ibps-rrb-po": {
    title: "IBPS RRB PO 2026: Comprehensive Syllabus & Eligibility",
    description: "Excel in the IBPS RRB PO 2026 exam. Detailed syllabus, eligibility requirements, and preparation strategies.",
  },
  "/exams/sbi-clerk": {
    title: "SBI Clerk 2026 Exam: Syllabus, Eligibility & Exam Pattern",
    description: "Your essential guide to the SBI Clerk 2026 exam. Covers syllabus, eligibility, and exam pattern for effective preparation.",
  },
  "/exams/ibps-rrb-clerk": {
    title: "IBPS RRB Clerk 2026: Syllabus & Eligibility Details",
    description: "Get the complete syllabus and eligibility information for the IBPS RRB Clerk 2026 exam at VIDYA365.",
  },
  "/results": {
    title: "VIDYA365 Coaching: Latest Student Results & Success Stories",
    description: "See our students' achievements! Explore the latest results and success stories from VIDYA365 coaching.",
  },
  "/student-benefits": {
    title: "VIDYA365 Delhi: Unlock Your Success with Top Student Benefits",
    description: "Discover the exclusive benefits at VIDYA365 Delhi: mock tests, doubt clearing, study materials, and expert mentorship.",
  },
  "/why-choose-us": {
    title: "Why VIDYA365 Delhi? Your Trusted Partner for SSC & Banking Exam Prep",
    description: "Choose VIDYA365 Delhi for your SSC, Banking, and government exam preparation. Trusted for success.",
  },
  "/study-materials": {
    title: "VIDYA365: Premium Study Materials for SSC & Banking Exams",
    description: "Access high-quality, comprehensive study materials for SSC, Banking, RBI, and other government exams at VIDYA365.",
  },
  "/previous-year-question-paper": {
    title: "VIDYA365: Download SSC & Banking Previous Year Question Papers",
    description: "Boost your exam prep! Download previous year question papers for SSC, Banking & other exams from VIDYA365.",
  },
  "/latest-updates": {
    title: "Latest SSC, Banking & RBI Exam Updates & Notifications | VIDYA365",
    description: "Stay ahead with the latest notifications, exam dates & government job updates for SSC, Banking, RBI, and more at VIDYA365.",
  },
  "/start-preparation": {
    title: "Start Your SSC & Banking Exam Prep with Expert Guidance at VIDYA365",
    description: "Begin your SSC and Banking exam preparation journey with structured guidance, study plans, and expert mentorship from VIDYA365.",
  },
  "/enroll-now": {
    title: "Enroll Now: SSC & Banking Coaching at VIDYA365 Delhi - Limited Seats!",
    description: "Secure your spot! Enroll in top SSC & Banking exam coaching at VIDYA365 Delhi. Limited seats available. Act fast!",
  },
  "/enquire-now": {
    title: "Enquire Now: VIDYA365 Delhi Coaching - Course Details & Support",
    description: "Have questions? Enquire now at VIDYA365 Delhi for course details, fees, batch timings, and enrollment assistance.",
  },
};

// Old → New URL redirect map. Source = old slug, target = new canonical.
export const URL_REDIRECTS = {
  "/features": "/student-benefits",
  "/resources": "/study-materials",
  "/pyq": "/previous-year-question-paper",
  "/Latest_update": "/latest-updates",
  "/contact": "/start-preparation",
};
